import { A9Service, AbstractDataProviderV2 } from 'components/system';

@A9Service('customerStackedRoundsYearStatisticsDataProvider')
export class customerStackedRoundsYearStatisticsDataProvider extends AbstractDataProviderV2 {
    constructor() {
        super();
        this.setApiUrl('middle://customers/statistics/stacked-rounds-played-year/{customerId}/{startYear}/{finishYear}');
    }
}
